export const BUSINESS_ROLE = "Бізнес-партнер";
export const DEFAULT_CHAT_ROLE = "Без визначеної ролі";

export const ROLE_TABS = [
  { role: BUSINESS_ROLE, label: "Бізнес-партнери" },
  { role: "Бібліотекар", label: "Бібліотекарі" },
  { role: "Майстер", label: "Майстри" },
  {
    role: 'Член "Клубу Майстрів"',
    label: "Члени Клубу Майстрів",
  },
];

function asText(value) {
  return typeof value === "string" ? value.trim() : "";
}

export function timestampToMillis(value) {
  if (typeof value?.toMillis === "function") return value.toMillis();
  if (typeof value?.seconds === "number") return value.seconds * 1000;
  if (typeof value === "number") return value;
  return 0;
}

export function buildConversations(chats, users) {
  const usersByUid = new Map();

  users.forEach((user) => {
    if (user?.id) usersByUid.set(user.id, user);
    if (user?.uid) usersByUid.set(user.uid, user);
  });

  return chats.map((chat) => {
    const uid = chat.uid || chat.id;
    const user = usersByUid.get(uid) || {};
    const role =
      asText(user.category) ||
      asText(chat.userRole) ||
      DEFAULT_CHAT_ROLE;
    const displayName =
      asText(user.displayName) ||
      asText(user.name) ||
      asText(chat.userName) ||
      asText(user.email) ||
      asText(chat.userEmail) ||
      uid;
    const email = asText(user.email) || asText(chat.userEmail);

    return {
      ...chat,
      uid,
      user,
      role,
      displayName,
      email,
      unread: Number(chat.unreadForAdmin) || 0,
      lastAtMillis: timestampToMillis(chat.lastAt),
    };
  });
}

export function buildRoleTabs(conversations) {
  const knownRoles = new Set(ROLE_TABS.map(({ role }) => role));
  const additionalRoles = [...new Set(
    conversations
      .map(({ role }) => asText(role) || DEFAULT_CHAT_ROLE)
      .filter((role) => !knownRoles.has(role)),
  )]
    .sort((first, second) => first.localeCompare(second, "uk-UA"))
    .map((role) => ({ role, label: role }));

  return [...ROLE_TABS, ...additionalRoles];
}

export function filterConversations(conversations, role, search) {
  const needle = asText(search).toLocaleLowerCase("uk-UA");

  return conversations
    .filter((conversation) => conversation.role === role)
    .filter((conversation) => {
      if (!needle) return true;
      return [
        conversation.displayName,
        conversation.email,
        conversation.role,
        conversation.uid,
      ].some((value) =>
        String(value || "")
          .toLocaleLowerCase("uk-UA")
          .includes(needle),
      );
    })
    .sort(
      (first, second) =>
        second.unread - first.unread ||
        second.lastAtMillis - first.lastAtMillis ||
        first.displayName.localeCompare(second.displayName, "uk-UA"),
    );
}

export function totalsByRole(conversations) {
  return conversations.reduce((totals, conversation) => {
    if (!totals[conversation.role]) {
      totals[conversation.role] = { count: 0, unread: 0 };
    }
    totals[conversation.role].count += 1;
    totals[conversation.role].unread += conversation.unread;
    return totals;
  }, {});
}

export function parseTelegramChatIds(value) {
  const values = Array.isArray(value)
    ? value
    : String(value || "").split(/[\s,;]+/);
  const valid = [];
  const invalid = [];

  values.forEach((item) => {
    const chatId = String(item || "").trim();
    if (!chatId) return;
    if (/^-?\d+$/.test(chatId) || /^@[A-Za-z0-9_]{5,}$/.test(chatId)) {
      if (!valid.includes(chatId)) valid.push(chatId);
    } else if (!invalid.includes(chatId)) {
      invalid.push(chatId);
    }
  });

  return { valid, invalid };
}
